import { render, staticRenderFns } from "./ListNew.vue?vue&type=template&id=26a2a57c&scoped=true&"
import script from "./ListNew.vue?vue&type=script&lang=js&"
export * from "./ListNew.vue?vue&type=script&lang=js&"
import style0 from "./ListNew.vue?vue&type=style&index=0&id=26a2a57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a2a57c",
  null
  
)

export default component.exports